export function isNewestFacebookConversation(conversation, latestFacebookConversationId) {
    if (!latestFacebookConversationId || !conversation.id) {
        return false;
    }
    return conversation.id >= latestFacebookConversationId;
}
